import {DraggableTree} from 'vue-draggable-nested-tree'
import swal from 'sweetalert'
import Import from '../import'
import store from '@/store/index'
export default {
  name: 'edit',
  components: {
    Tree: DraggableTree,
    Import
  },
  props: [],
  data () {
    return {
      document_item: {},
      selectItem: {},
      edit: true,
      is_add: false,
      document_item_add: {},
      loading: false,
      errors: {},
    }
  },
  computed: {
    document_items () {
      return this.$store.getters['DocumentItem/getListDocumentItem']
    },
    document () {
      return this.$store.getters['Document/getDocument']
    }
  },
  mounted () {
    this.$loading.start()
    // this.loading = true
    Promise.all([
      _.isEmpty(this.document) ? this.$store.dispatch('Document/showDocument', {document: {id: this.$route.params.document_id}}): '',
      this.document_items == '' ? this.$store.dispatch('DocumentItem/getListDocumentItem', {document: {id: this.$route.params.document_id}}): ''
    ]).then(res => {
      this.document = res[0]
      if (this.document_items.length) {
        this.selectItem = this.document_items[0]
        Object.assign(this.document_item, this.selectItem)
      }
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      console.log(errors)
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    select (documentItem) {
      this.selectItem = documentItem
      this.edit = true
      this.document_item = {}
      Object.assign(this.document_item, documentItem)
      this.is_add = false
    },
    // editMode (selectItem) {
    //   this.$loading.start()
    //   this.$store.dispatch('DocumentItem/showDocumentItem', {document_item: selectItem}).then(res => {
    //     this.document_item = res
    //     this.edit = !this.edit
    //     this.$loading.complete()
    //   }).catch(errors => {
    //     this.$loading.fail()
    //   })
    // },
    cancel () {
      this.edit = true
      this.is_add = false
    },
    save () {
      this.$loading.start()
      var data = {}
      data.doc_id = this.$route.params.document_id
      data.parent_id = this.document_item.parent_id
      data.content = this.document_item.content
      data.index = this.document_item.index
      data.header = this.document_item.header
      data.id = this.document_item.id
      this.$store.dispatch('DocumentItem/updateDocumentItem', {document_item: data}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.selectItem = res
        this.$loading.complete()
        this.error = ''
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },
    // ondrag (node) {
    //   if (node.parent.id !== undefined) {
    //     node.parent_id = node.parent.id
    //   } else {
    //     node.parent_id = 0
    //   }
    //   this.document_item.parent_id = node.parent_id
    //   this.document_item.id = node.id
    //   this.document_item.index = node.index
    //   this.document_item.header = node.header
    //   this.document_item.content = node.content
    //   this.document_item.doc_id = node.document.id
    //   this.$loading.start()
    //   this.$store.dispatch('DocumentItem/updateDocumentItem', {document_item: this.document_item}).then(res => {
    //     this.$loading.complete()
    //   }).catch(errors => {
    //     this.$loading.fail()
    //   })
    // },

    addDoc (flag) {
      this.is_add = true
      this.edit = false
      this.document_item_add = {}
      this.errors = {}
      this.document_item_add.parent_id = flag === 1 ? this.selectItem.id : 0
      this.document_item_add.doc_id = this.$route.params.document_id
    },
    create () {
      this.$loading.start()
      this.$store.dispatch('DocumentItem/createDocumentItem', {document_item: this.document_item_add}).then(res => {
        // this.selectItem = res
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.addDoc(1)
        this.document_item_add.content = ''
        this.$loading.complete()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },

    loadingImport (loading) {
      // this.loading = loading
      // this.$router.push('/')
      this.$store.dispatch('DocumentItem/setDocumentQueue', this.$route.params.document_id)
    },

    destroy () {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('DocumentItem/destroyDocumentItem', {
              document_item: this.selectItem
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
              this.selectItem = this.document_items[0]
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },
    UploadAdapter (loader) {
      this.loader = loader
      this.upload = function () {
        const body = new FormData()
        body.append('image', this.loader.file)
        return store.dispatch('DocumentItem/uploadImageDocumentItem', {data: body})
          .then(downloadUrl => {
            return {
              default: downloadUrl
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document-item/edit/edit.js